<template>
  <!-- https://www.npmjs.com/package/vue-cleave-component -->
  <cleave

    v-bind="{
      ...$attrs,
      options,
      raw: 'masked-value' in $attrs == false,
    }"

    v-on="$listeners"

    class="imd-sm-input"
    :class="{
      'right' : 'right' in $attrs
    }"

  >
  </cleave>

</template>

<style>
.imd-input-mask.right { text-align: right; }
input.imd-sm-input.imd-input-mask { height: 22px; padding-top: 2px;  }

</style>


<script>
import Cleave from 'vue-cleave-component';
export default {
  props : {
    maxlength: {
        type: Number,
        default: 9
    },
  },
  inheritAttrs: false,
  components: { Cleave },
  data () {
    return {
      options: {
        prefix: '',
        numeral: true,
        numeralPositiveOnly: true,
        noImmediatePrefix: true,
        rawValueTrimPrefix: true,
        numeralIntegerScale: this.maxlength,
        numeralDecimalScale: 0
      }
    }
  }
}
</script>

